var _path, _path2, _path3, _rect, _rect2, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgDisease(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4151 7.86011V15.9751C20.4068 19.9978 17.1478 23.2569 13.1251 23.2651V23.2651C9.1048 23.2568 5.85009 19.9954 5.8501 15.9751",
    stroke: "#506C8E",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0785 8.53986C22.723 8.06246 23.7531 6.41869 23.4754 4.71493C23.1977 3.01118 21.7002 1.78681 19.9907 1.86593C18.2813 1.94505 16.9011 3.30261 16.7792 5.02486C16.6573 6.74711 17.8322 8.28883 19.5131 8.6123L21.0785 8.53986ZM19.7735 6.59959C19.1346 6.43802 18.6865 5.85864 18.6865 5.19407C18.6865 4.52949 19.1346 3.95011 19.7735 3.78855C20.3536 3.64186 20.963 3.87325 21.3034 4.3694C21.6438 4.86555 21.6438 5.52259 21.3034 6.01874C20.963 6.51489 20.3536 6.74628 19.7735 6.59959ZM17.832 5.15047C17.832 3.92534 18.8697 2.91489 20.1716 2.91489C20.7706 2.91489 21.3152 3.12966 21.728 3.48172C21.8331 3.57132 21.9909 3.55878 22.0805 3.45372C22.1701 3.34866 22.1575 3.19087 22.0525 3.10128C21.5508 2.67349 20.8917 2.41489 20.1716 2.41489C18.6131 2.41489 17.332 3.63007 17.332 5.15047C17.332 5.97013 17.7058 6.70329 18.2937 7.20243C18.399 7.29179 18.5568 7.27891 18.6461 7.17366C18.7355 7.0684 18.7226 6.91064 18.6173 6.82128C18.1336 6.41058 17.832 5.8135 17.832 5.15047Z",
    fill: "#506C8E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.155 3V11.67C10.155 14.0476 8.22761 15.975 5.85003 15.975V15.975C4.69928 15.9911 3.59032 15.5442 2.77232 14.7346C1.95433 13.9251 1.49589 12.8208 1.50003 11.67V3",
    stroke: "#506C8E",
    strokeWidth: 0.75
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1.5,
    width: 3,
    height: 3,
    rx: 1.03,
    fill: "#506C8E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 1.5,
    width: 3,
    height: 3,
    rx: 1.03,
    fill: "#506C8E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 11.0849C3.48 11.8949 8.565 12.1199 10.005 11.3099",
    stroke: "#506C8E",
    strokeWidth: 0.75
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisease);
export default __webpack_public_path__ + "static/media/Disease.96da10ab17186fed90042609d0693c6e.svg";
export { ForwardRef as ReactComponent };